/**
 * Where a product photo comes from.
 *
 * Mock: the Vite dev server mounts the pack's media directory at /mock-media (see vite.config.ts),
 * so the Catalogue and the thread show the real furniture while the API is being written.
 * Real: `GET /api/v1/media/:id`, which applies the role check and signs the path.
 *
 * A production `vite build` has no /mock-media route; Gallery's <img> onError falls back to a
 * labelled placeholder rather than a broken-image icon, which is the honest state.
 *
 * Author: Danish Khan
 */
import type { Media } from './types.ts';
import { API_SOURCE } from './api.ts';

export function mediaUrl(media: Media): string {
  return API_SOURCE === 'mock' ? `/mock-media/${media.path}` : `/api/v1/media/${media.id}`;
}
